export function readIssues(payload: unknown): unknown[] | undefined {
  if (!payload || typeof payload !== "object") {
    return undefined;
  }
  const data = (payload as { data?: unknown }).data;
  if (!data || typeof data !== "object") {
    return undefined;
  }
  const issues = (data as { issues?: unknown }).issues;
  return Array.isArray(issues) ? issues : undefined;
}
